import classNames from 'classnames';
import { Heading } from 'components/1-atoms/Heading';
import { RichText } from 'components/1-atoms/RichText';
import IconPhone from 'icons/phone.svg';
import { customizeElement } from 'utilities/customizeElement';
import styles from './ContactBox.module.scss';

export interface ContactBoxProps {
	className?: string;
	noPadding?: boolean;
	heading?: string;
	contactText?: string;
	phoneNumberLink?: React.ReactElement;
	currentWaitingTime?: string;
	openingHours?: string;
}

export const ContactBox: React.FC<ContactBoxProps> = ({
	className,
	noPadding,
	heading,
	contactText,
	phoneNumberLink,
	currentWaitingTime,
	openingHours,
}) => (
	<section className={classNames(styles.ContactBox, noPadding && styles.ContactBox___noPadding, className)}>
		{heading && (
			<div className={styles.ContactBox_heading}>
				<Heading headingLevel="h2" style="sm">
					{heading}
				</Heading>
			</div>
		)}
		<div className={styles.ContactBox_container}>
			<div className={styles.ContactBox_phoneWrapper}>
				<IconPhone />
			</div>
			<div className={styles.ContactBox_contactWrapper}>
				{phoneNumberLink && (
					<>
						<RichText className={styles.ContactBox_text} content={contactText} />
						{customizeElement({ element: phoneNumberLink, style: styles.ContactBox_link })}
					</>
				)}
				{openingHours && <RichText className={styles.ContactBox_text} content={openingHours} />}
				{currentWaitingTime && <RichText className={styles.ContactBox_text} content={currentWaitingTime} />}
			</div>
		</div>
	</section>
);
